<template>
<svg width="38" height="38" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg">
  <path d="M20.7861 0V17.2137H37.9998C37.9998 7.6866 30.3132 0 20.7861 0ZM24.034 3.68091C29.1223 4.87179 33.0197 8.87749 34.3189 13.9658H24.034V3.68091Z" fill="currentColor"/>
  <path d="M17.1054 38C26.6325 38 34.3191 30.3134 34.3191 20.7864H17.2137V3.68097C7.6866 3.68097 0 11.3676 0 20.7864C0 30.2052 7.68661 38 17.1054 38Z" fill="currentColor"/>
</svg>
</template>
